import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(typeof data.detail === "string" ? data.detail : "Invalid credentials");
        return;
      }
      localStorage.setItem("admin_token", data.token);
      navigate("/admin/dashboard");
    } catch {
      setError("Connection failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <a href="/" className="inline-flex items-center gap-1.5 text-sm text-[#5C5A56] hover:text-[#D36135] mb-8 transition-colors" data-testid="back-to-site-link">
          <ArrowLeft size={16} /> Back to site
        </a>

        <div className="bg-white rounded-2xl p-8 shadow-[0_8px_40px_rgba(45,44,42,0.08)] border border-[#E6E4DF]">
          <div className="text-center mb-6">
            <div className="w-12 h-12 bg-[#2D2C2A] rounded-xl flex items-center justify-center mx-auto mb-3">
              <Lock size={20} className="text-white" />
            </div>
            <h1 className="text-xl font-bold text-[#2D2C2A]">Admin Console</h1>
            <p className="text-sm text-[#5C5A56] mt-1">Truths, Chaos & Cupcakes</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-[#5C5A56] mb-1.5">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-2.5 rounded-xl border border-[#E6E4DF] bg-[#F9F8F6] text-sm focus:outline-none focus:border-[#D36135] transition-colors"
                placeholder="Steve"
                required
                data-testid="admin-username-input"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#5C5A56] mb-1.5">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2.5 rounded-xl border border-[#E6E4DF] bg-[#F9F8F6] text-sm focus:outline-none focus:border-[#D36135] transition-colors"
                placeholder="Enter password"
                required
                data-testid="admin-password-input"
              />
            </div>

            {error && (
              <p className="text-red-500 text-xs text-center" data-testid="admin-login-error">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#2D2C2A] hover:bg-[#D36135] text-white font-medium py-2.5 rounded-xl transition-colors text-sm disabled:opacity-50"
              data-testid="admin-login-button"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
